
































































import { createComponent } from "@vue/composition-api";
import { getActions } from "@dcc/store/drinking/actions";
import { useRouting } from "@dcc/compositions/useRouting";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import {
  BaseActionButton,
  BaseActionButtonGroup,
  BaseDrinkInfo,
  BaseLink
} from "@web-components";
import { BingeFrequency } from "@dcc/types/bingeFrequency";
import { findGetters as profileGetters } from "@dcc/store/profile/getters";
import { findGetters as drinkGetters } from "@dcc/store/drinking/getters";
import { bingeDrinkAmounts } from "@dcc/types/bingeFrequency";
import { getDrinkDescriptions } from "@dcc/constants/drinkConstants";

export default createComponent({
  components: {
    BaseActionButton,
    BaseActionButtonGroup,
    BaseLink,
    BaseDrinkInfo
  },
  setup(props: {}, context) {
    const { handleNext, handlePrev } = useRouting(context);
    const dictionary = useDictionary();

    const { getGender } = profileGetters(context.root.$store);
    const gender = getGender();

    const { getBingeFrequency } = drinkGetters(context.root.$store);
    const bingefrequency = getBingeFrequency();

    const { updateBingeFrequency } = getActions(context.root.$store);
    const handleSelected = (value: number) => {
      updateBingeFrequency(value);
      handleNext();
    };

    const drinkDescriptions = getDrinkDescriptions();

    return {
      drinkDescriptions,
      bingeDrinkAmounts,
      handleSelected,
      handlePrev,
      BingeFrequency,
      bingefrequency,
      gender,
      ...dictionary
    };
  }
});
